import BaseSocketClient from '@/utils/ws/baseSocketClient.js'
import { SOCKET_RECONNECT_EVENT } from '@/utils/constant.js'

class MSocket extends BaseSocketClient {
  static instance = null

  static autoConnect () {
    if (!this.instance) {
      this.instance = new MSocket()
    }
    return this.instance.connect()
  }

  static instanceClose () {
    if (!this.instance) {
      return
    }

    this.instance.isManualClose = true
    this.instance.closeRaw?.()
    this.instance.cleanup()
    this.instance = null
  }

  constructor () {
    super({
      wsUrl,
      reconnectEventName: SOCKET_RECONNECT_EVENT,
      logPrefix: 'socket'
    })
  }

  close () {
    MSocket.instanceClose()
  }
}

export default MSocket
